var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.$gettext('GPS Track')}},[_c('icon-geometry-detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }